import Immutable from 'immutable';
import { applyMiddleware, compose, createStore } from 'redux';
import thunk from 'redux-thunk';
var middleware = [thunk];

function finalCreateStore(_ref) {
  var debug = _ref.debug;

  if (debug && window.__REDUX_DEVTOOLS_EXTENSION__) {
    var reduxDevtools = window.__REDUX_DEVTOOLS_EXTENSION__({
      serialize: {
        immutable: Immutable
      }
    });

    return compose(applyMiddleware.apply(void 0, middleware), reduxDevtools)(createStore);
  } else {
    return compose(applyMiddleware.apply(void 0, middleware))(createStore);
  }
}

export default function configureStore(_ref2) {
  var debug = _ref2.debug,
      reducer = _ref2.reducer;
  return finalCreateStore({
    debug: debug
  })(reducer);
}